import { Controller } from "@hotwired/stimulus"

const EVENT_NAME = "search_results"
// GA4のイベントパラメータの値は100文字まで
const MAX_PARAM_LENGTH = 100

type GtagFn = (command: "event", eventName: string, params: Record<string, unknown>) => void

// Connects to data-controller="search-results-tracking"
// サービス検索の結果の件数と絞り込みの条件をGA4に送信する（#1510）
// 検索した言葉は自動計測の view_search_results でも届くが、件数と条件は届かないため別のイベントで送る。
// ページ送りで同じ検索が重複しないよう、1ページ目だけに付ける（search_results_tracking_data で制御）
export default class extends Controller {
  static values = {
    term: String,
    count: Number,
    // 絞り込みの条件。キーワードとの組み合わせで0件になったのかを見分けるために送る
    categoryId: Number, // 小カテゴリを指定していれば小カテゴリ、大カテゴリだけなら大カテゴリのID。0 は指定なし
    rewardLower: Number, // 価格帯の下限。0 は指定なし
    rewardUpper: Number, // 価格帯の上限。0 は指定なし
    accepting: Boolean,
    beginner: Boolean,
    followingOnly: Boolean,
    rankFiltered: Boolean // 会員区分のチェックを外して絞り込んでいるか（全部外したときは絞り込みが効かないので false）
  }

  declare readonly termValue: string
  declare readonly countValue: number
  declare readonly categoryIdValue: number
  declare readonly rewardLowerValue: number
  declare readonly rewardUpperValue: number
  declare readonly acceptingValue: boolean
  declare readonly beginnerValue: boolean
  declare readonly followingOnlyValue: boolean
  declare readonly rankFilteredValue: boolean

  connect(): void {
    const gtag = (window as unknown as { gtag?: GtagFn }).gtag
    if (typeof gtag !== "function") return

    gtag("event", EVENT_NAME, {
      search_term: this.termValue.slice(0, MAX_PARAM_LENGTH),
      results_count: this.countValue,
      category_id: this.categoryIdValue,
      reward_lower: this.rewardLowerValue,
      reward_upper: this.rewardUpperValue,
      accepting: this.acceptingValue,
      beginner: this.beginnerValue,
      following_only: this.followingOnlyValue,
      rank_filtered: this.rankFilteredValue
    })
  }
}
